import React, { useState, useEffect, useRef } from "react";
import Header from "./Header";
import SideBar from "./Sidebar";
import { getCustomerFields2 } from "../../Services/fieldsServices";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { getCustomerControlField } from "../../Services/customerServices";
import _ from 'lodash';
import ToastElement from "../UiComponents/ToastElement";
import Loader from "../UiComponents/Loader";
import { useLoginPermissionProvider } from "../../Providers/LoginPermissionProvider";

const Layout = (props) => {
  const [headerLabel, setHeaderLabel] = useState("");
  const [menuClick, setMenuClick] = useState(false);
  const [customerId, setCustomerId] = useState(null);
  const [moduleDetails, setModuleDetails] = useState([]);
  const [myAccountDetails, setMyAccountDetails] = useState({});
  const [clientsDetails, setClientsDetails] = useState({});
  const [frameworksDetails, setFrameworksDetails] = useState({});
  const [addressBookDetails, setAddressBookDetails] = useState({});
  const [pipelineDetails, setPipelineDetails] = useState({});
  const [dashboardDetails, setDashboardDetails] = useState({});
  const [businessPlanDetails, setBusinessPlanDetails] = useState({});
  const [targetPlanDetails, setTargetPlanDetails] = useState({});
  const [commonFieldsDetails, setCommonFieldsDetails] = useState({});
  const [benchmarkingDetails, setBenchmarkingDetails] = useState({});
  const [displayName, setDisplayName] = useState({});
  const [customerControlFields, setCustomerControlFields] = useState(null);
  const [subMenus, setSubMenus] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false)
  const [activeTab, setActiveTab] = useState(null);
  const navigate = useNavigate()
  const toastRef = useRef();

  const { globalLoginPermission } = useLoginPermissionProvider();

  let location = useLocation();
  const childRef = useRef();
  const activeTabRef = useRef(null);

  const callChildFunction = (url) => {
    if (childRef.current) {
      childRef.current.childFunction(url); // Call the function in the child
    }
  };

  useEffect(() => {
    const enduserStr = localStorage.getItem("enduser");
    if (enduserStr) {
      const enduser = JSON.parse(enduserStr);
      const customer = enduser.customer;
      setCustomerId(customer);
    } else {
      navigate("/login")
      localStorage.clear()
    }
  }, []);

  useEffect(() => {
    getCustomerField();
    getCustomerFieldData();
  }, [customerId, globalLoginPermission?.isBranchAdmin]);
  
  useEffect(() => {
    if (!location.pathname.startsWith('/controlPanel')) {
      activeTabRef.current = null
    }
  }, [location])

  const hamburgerClick = (menuOpen) => {
    if (menuOpen) {
      setMenuClick(true);
    } else {
      setMenuClick(false);
    }
  }

  const onSelectOpen = (isOpen) => {
    if (isOpen) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }

  const getCustomerFieldData = async function () {
    if (customerId !== null) {
      const customerDAta = await getCustomerControlField(customerId);
      let displayNames = [];
      if(customerDAta && customerDAta.data){
        customerDAta.data.cust[0]?.modules[0]?.tabs.forEach((item) => {
          displayNames.push({ label: item.display_name.toUpperCase() });
        });
  
        const filteredDisplayNames = globalLoginPermission?.isBranchAdmin
          ? displayNames.filter(item =>
            ["USERS", "USAGE LOG", "PERMISSIONS", "USER CLASSIFICATION"].includes(item.label)
          )
          : displayNames;
        const navigationData = filteredDisplayNames?.map((item, index) => ({
          label: _.startCase(_.camelCase(item.label)),
          command: () => {
            const newTab = item.label;
            callChildFunction('/controlPanel/' + newTab.replace(/ /g, "").toLowerCase());
            activeTabRef.current = newTab;
            setActiveTab(newTab);
          },
          icon: globalLoginPermission?.isBranchAdmin ? getIconForBranchAdmin(index) : getIconForIndex(index), // Use a function to get the icon
          template: (navItem) => {
            const path = `/controlPanel/${navItem.label.replace(/ /g, "").toLowerCase()}`; // Convert label to lowercase and remove spaces
            const isActive = activeTabRef.current != null && _.startCase(_.camelCase(activeTabRef.current)) === navItem.label;
            return (
              <div className={isActive ? 'active-menu-item' : ''}>
                <a href={path || '#'} className="submenu-link" >
                  <i className={`${globalLoginPermission?.isBranchAdmin ? getIconForBranchAdmin(index) : getIconForIndex(index)}`}></i>
                  <span>{_.startCase(_.camelCase(navItem.label))}</span>
                </a>
              </div>
            );
          }
        }));
  
        // Function to get icons based on index
        function getIconForIndex(index) {
          const icons = [
            'pi pi-play',
            'pi pi-user',
            'pi pi-check',
            'pi pi-angle-double-right',
            'pi pi-ticket',
            'pi pi-list',
            'pi pi-question-circle',
            'pi pi-chart-bar',
            'pi pi-lightbulb',
            'pi pi-check-square',
            'pi pi-users',
            'pi pi-bars',
            'pi pi-info-circle',
            'pi pi-lock',
            'pi pi-inbox',
            'pi pi-credit-card',
            'pi pi-sliders-h',
            'pi pi-table',
            'pi pi-cog',
            'pi pi-inbox',
            'pi pi-clipboard',
            'pi pi-file'
          ];
  
          return icons[index] || null; // Return the icon or null if index exceeds the array length
        }
  
        function getIconForBranchAdmin(index) {
          const icons = [
            'pi pi-user',
            'pi pi-check',
            'pi pi-ticket',
            'pi pi-users',
  
          ];
  
          return icons[index] || null; // Return the icon or null if index exceeds the array length
        }
  
        setSubMenus(navigationData)
        setCustomerControlFields(displayNames);
      }
      
    }
  };

  const getCustomerField = async function () {
    if (customerId !== null) {
      setLoading(true)
      const customerDAta = await getCustomerFields2(customerId);
      if(customerDAta && customerDAta.data){
        let data = customerDAta?.data?.cust[0]?.modules;
        let moduleOrder = [
          "Dashboard",
          "Pipeline",
          "Clients",
          "Frameworks",
          "Address Book",
          "Business Plan",
          "Target Plan",
          "My Account",
          "Benchmarking",
        ];
        let moduleURL = [
          '/dashboard',
          '/portfolio',
          '/stakeholder',
          '/programme',
          '/addressbook',
          '/businessPlan',
          '/targetPlan',
          '/myAccount',
          '/benchmarking'
        ]
        let displayNames = [];
  
        moduleOrder.forEach((moduleName, index) => {
          const module = data.find(
            (item) => item.module_name === moduleName && item.status === true
          );
          if (module) {
            displayNames.push({display_name: module.display_name, status: true});
          }
          else{
            displayNames.push({status: false});
            if(location.pathname.startsWith(moduleURL[index])){
              navigate('/accessDenied')
            }
          }
        });
        setDisplayName(displayNames);
        if (data) {
          const MyAccountDetails = _.find(data, { module_name: "My Account", status: true });
          setMyAccountDetails(MyAccountDetails);
  
          const Clients = _.find(data, { module_name: "Clients", status: true });
          setClientsDetails(Clients);
  
          const Frameworks = _.find(data, { module_name: "Frameworks", status: true });
          setFrameworksDetails(Frameworks);
  
          const AddressBook = _.find(data, { module_name: "Address Book", status: true });
          setAddressBookDetails(AddressBook);
          const Pipeline = _.find(data, { module_name: "Pipeline", status: true });
          setPipelineDetails(Pipeline);
          const Dashboard = _.find(data, { module_name: "Dashboard", status: true });
  
          setDashboardDetails(Dashboard);
  
          const BusinessPlan = _.find(data, { module_name: "Business Plan", status: true });
          setBusinessPlanDetails(BusinessPlan);
  
          const TargetPlan = _.find(data, { module_name: "Target Plan", status: true });
          setTargetPlanDetails(TargetPlan);
  
          const CommonFields = _.find(data, { module_name: "Common Fields", status: true });
          setCommonFieldsDetails(CommonFields);
  
          const Benchmarking = _.find(data, { module_name: "Benchmarking", status: true });
          setBenchmarkingDetails(Benchmarking);
          setModuleDetails(data);
          setLoading(false)
        }
      }
    }
  };

  useEffect(() => {
    if (location.pathname.startsWith("/dashboard")) {
      setHeaderLabel(dashboardDetails?.display_name);
    } else if (location.pathname.startsWith("/portfolio")) {
      setHeaderLabel(pipelineDetails?.display_name);
    } else if (location.pathname.startsWith("/stakeholder")) {
      setHeaderLabel(clientsDetails?.display_name);
    } else if (location.pathname.startsWith("/programme")) {
      setHeaderLabel(frameworksDetails?.display_name);
    } else if (location.pathname === "/addressbook") {
      setHeaderLabel(addressBookDetails?.display_name);
    } else if (location.pathname.startsWith("/businessPlan")) {
      setHeaderLabel(businessPlanDetails?.display_name);
    } else if (location.pathname.startsWith("/targetPlan")) {
      setHeaderLabel(targetPlanDetails?.display_name);
    } else if (location.pathname.startsWith("/benchmarking")) {
      setHeaderLabel(benchmarkingDetails?.display_name);
    } else if (location.pathname.startsWith("/controlPanel")) {
      setHeaderLabel("Control Panel");
    } else if (location.pathname === "/myAccount") {
      setHeaderLabel(myAccountDetails?.display_name);
    }
  }, [location.pathname, props.value, pipelineDetails, dashboardDetails, clientsDetails, frameworksDetails, addressBookDetails, businessPlanDetails, targetPlanDetails, benchmarkingDetails, myAccountDetails]);

  return (
    <div>
      <Loader loading={loading} />
      <ToastElement ref={toastRef} />
      <SideBar
        isOpen={menuClick}
        onSelectHamburger={() => hamburgerClick()}
        ref={childRef}
        displayName={displayName}
        submenus={subMenus}
        onSelectOpen={(data) => onSelectOpen(data)}
        isRestricted={globalLoginPermission?.isRestricted}
        isAdmin={globalLoginPermission?.isAdmin}
        isBranchAdmin={globalLoginPermission?.isBranchAdmin}
      />
      <div className={isOpen ? "content" : "contentClosed"}>
        <div className="header-content">
          <Header
            isOpen={menuClick}
            onSelectHamburger={hamburgerClick}
            headerLabel={headerLabel}
          />
        </div>
        <div className="outlet-content">
          <Outlet></Outlet>
        </div>
      </div>
    </div>
  );
};

export default Layout;
